<template>
  <a-modal
    title="Aprobar reconocimiento"
    :visible="visible"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :model="record" v-bind="fiOptions" :rules="formRules"
                  ref="form">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colSpan">
          <p>{{getMessage}}</p>
          <a-form-model-item v-bind="fiOptions" :label="$t('Observaciones')" prop="comments" has-feedback>
            <a-textarea style="width: 100%"
                        v-model="record.comments"/>
          </a-form-model-item>
          <a-form-model-item v-if="oculta_campos" :label="$t('Fecha del evento')" prop="delivery_date" has-feedback>
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-model="record.delivery_date"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    data () {
      return {
        formRules: {},
        colSpan: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 6},
          'wrapper-col': {span: 18},
          'has-feedback': true
        },
        visible: false,
        loading: false,
        record: {},
        oculta_campos: false,
        approval: null
      }
    },
    methods: {
      initFormRules () {
        this.formRules = {
          delivery_date: [{required: true, message: 'Valor requerido'}],
          comments: [{required: true, message: 'Valor requerido'}]
        }
      },
      showModal ({record, oculta_campos, approval}) {
        this.visible = true
        this.record = record
        this.approval = approval
        // eslint-disable-next-line camelcase
        this.oculta_campos = oculta_campos
      },
      handleOk (e) {
        if (this.loading) return
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true
            let req = {
              ...this.record,
              approval: this.approval
            }
            this.httpClient.getInstance().put('gestion_humana/reconocimiento/' + this.record.id_recognition, req)
              .then(() => {
                this.$emit('handleOk')
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
                this.visible = false
              })
          }
        })
      },
      handleCancel (e) {
        this.visible = false
      }
    },
    computed: {
      getMessage () {
        if (this.approval) {
          return '¿Esta seguro que desea aprobar este reconocimiento?'
        } else {
          return '¿Esta seguro que desea rechazar este reconocimiento?'
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Reconocimiento/ModalAprobacionReconocimiento.vue